import React from "react";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { NotesSection } from "../../common/components/notes/NotesSection";
import { OrderAssetsSection } from "./assets/OrderAssetsSection";
import { OrderDeliverySection } from "./delivery/OrderDeliverySection";
import { OrderDetailsSection } from "./details/OrderDetailsSection";
import { OrderMaterialSpecificationSection } from "./material-specification/OrderMaterialSpecificationSection";
import { OrderMetadataSection } from "./metadata/OrderMetadataSection";
import { OrderWarningSection } from "./metadata/OrderWarningSection";
import { OrderDashboardHeader } from "./OrderDashboardHeader";
import { OrderOutputsSection } from "./outputs/OrderOutputsSection";
import { OrderDashboardProvider } from "./provider/OrderDashboardProvider";
import { OrderProxiesSection } from "./proxies/OrderProxiesSection";

export const OrderDashboard: React.FC = () => {
    return (
        <OrderDashboardProvider>
            <OrderDashboardHeader />
            <OrderWarningSection />
            <Grid>
                <GridRow>
                    <GridColumn sm={6}>
                        <OrderDetailsSection height={400} />
                    </GridColumn>
                    <GridColumn sm={6}>
                        <OrderDeliverySection height={400} />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <OrderAssetsSection height={400} />
                    </GridColumn>
                </GridRow>
                <GridRow style={{ display: "flex", alignItems: "stretch" }}>
                    <GridColumn sm={6} style={{ display: "flex" }}>
                        <OrderMaterialSpecificationSection minHeight={400} />
                    </GridColumn>
                    <GridColumn sm={6} style={{ display: "flex" }}>
                        <NotesSection style={{ minHeight: 400, flex: 1 }} />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <OrderOutputsSection height={400} />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <OrderProxiesSection height={500} />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <OrderMetadataSection minHeight={400} />
                    </GridColumn>
                </GridRow>
            </Grid>
        </OrderDashboardProvider>
    );
};
